import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonSettings } from 'src/app/models/button-settings.model';
import { AccessibilityService } from 'src/app/services/accessibility.service';
import { StakeholderService } from 'src/app/services/stakeholder.service';

import { CardButtonComponent } from '../../shared-modules/card-button/card-button.component';
import { BreadcrumbComponent, BreadcrumbItem } from '../../shared-modules/breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-initialisation',
    templateUrl: './initialisation.component.html',
    styleUrls: ['./initialisation.component.scss'],
    imports: [CardButtonComponent, BreadcrumbComponent]
})
export class InitialisationComponent {
  private router = inject(Router);
  private stakeholderService = inject(StakeholderService);

  public readonly id: string = AccessibilityService.defaultContentId;

  public readonly breadcrumbs: BreadcrumbItem[] = [
    { label: 'Home', link: '/landing-page' },
    { label: 'Instellingen' }
  ];

  private static EMAIL_LABEL = 'Stakeholders uitnodigen';

  public buttonSettings: ButtonSettings[] = [
    {
      fontIcon: 'group_add',
      label: 'Stakeholders definiëren',
      routerLink: '/stakeholders'
    },
    {
      fontIcon: 'list_alt',
      label: 'Items en taken definiëren',
      routerLink: '/assign-items'
    },
    {
      fontIcon: 'mail',
      label: InitialisationComponent.EMAIL_LABEL,
      routerLink: '/initialisation',
      tooltip: `Door op deze knop te klikken worden automatisch uitnodigingen verstuurd naar alle gedefinieerde stakeholders en ondersteunende partijen om deel te nemen aan dit handelingsperspectief.
      Heeft u nieuwe stakeholders toegevoegd? Dan ontvangen alleen de nieuw toegevoegde personen een uitnodigingsmail.`
    }
  ];

  public onClick(event: ButtonSettings) {
    if (event.label === InitialisationComponent.EMAIL_LABEL) {
      this.stakeholderService.inviteStakeholders().subscribe({
        next: (v: any) => this.router.navigate(['/landing-page']),
        error: (e: any) => console.error(e)
      });;
    }
  }

}
